import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8de3c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "measures-container"
}
const _hoisted_2 = { class: "d-flex justify-content-between mb-24" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 1,
  class: "container bg-white rounded-1 p-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_multiple_button_select = _resolveComponent("v-multiple-button-select")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_the_form_anamnesis = _resolveComponent("the-form-anamnesis")!
  const _component_the_form_nutritional_anamnesis = _resolveComponent("the-form-nutritional-anamnesis")!
  const _component_the_anamnesis_results_modal = _resolveComponent("the-anamnesis-results-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!_ctx.currentExpedient.rgpdConfirmedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_multiple_button_select, { "div-class": "mb-16" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_button, {
                  variant: "multiple-pills",
                  class: _normalizeClass(["rounded-pill", {'active': _ctx.view === 'nutritional_anamnesis'}]),
                  "aria-label": _ctx.$t('Nutricional'),
                  onClick: _ctx.chooseNutritionalAnamnesis
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Nutricional')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "aria-label", "onClick"]),
                _hoisted_3,
                _createVNode(_component_v_button, {
                  variant: "multiple-pills",
                  class: _normalizeClass(["rounded-pill", {'active': _ctx.view === 'protocol_anamnesis', 'text-secondary': _ctx.currentTreatment}]),
                  "aria-label": _ctx.$t('De protocolo'),
                  onClick: _ctx.chooseProtocolAnamnesis
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('De protocolo')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "aria-label", "onClick"])
              ]),
              _: 1
            })
          ]),
          (!_ctx.anamnesis_loaded)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.view === 'protocol_anamnesis' && _ctx.anamnesis_loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_the_form_anamnesis, {
                  "form-version": _ctx.currentAnamnesis.version,
                  "form-type": _ctx.currentAnamnesis.type,
                  "form-structure": _ctx.currentAnamnesisStructure,
                  onAlertsUpdated: _ctx.handleAnamnesisAlertsUpdatedEvent
                }, null, 8, ["form-version", "form-type", "form-structure", "onAlertsUpdated"]),
                _createVNode(_component_v_button, {
                  variant: "secondary",
                  "aria-label": _ctx.$t('Finalizar'),
                  onClick: _ctx.openTheAnamnesisResultsModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Finalizar')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"])
              ]))
            : (_ctx.view === 'nutritional_anamnesis' && _ctx.anamnesis_loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.anamnesis_loaded)
                    ? (_openBlock(), _createBlock(_component_the_form_nutritional_anamnesis, {
                        key: 0,
                        "form-version": _ctx.currentNutritionalAnamnesis.version,
                        "form-type": _ctx.currentNutritionalAnamnesis.type,
                        "form-structure": _ctx.currentNutritionalAnamnesisStructure
                      }, null, 8, ["form-version", "form-type", "form-structure"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('Politicas RGPD no aceptadas en el expediente')), 1)),
    (_ctx.modalToShow === 'the-anamnesis-results-modal')
      ? (_openBlock(), _createBlock(_component_the_anamnesis_results_modal, {
          key: 2,
          alerts: _ctx.anamnesisAlerts,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = null)),
          onTreatmentStarted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.view = 'nutritional_anamnesis'))
        }, null, 8, ["alerts"]))
      : _createCommentVNode("", true)
  ], 64))
}